import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet-async";

export default function Gmfitaly() {
  return (
    <>
        <Helmet>
            <title>GMF Italy | Gandhi Mandela Foundation</title>
            <meta name="description" content="GMF Italy" />
        </Helmet>
      <Header />
        <div>
        <section className="page-header">
            <div className="container">
            <div className="breadcrumb">
                <a href="/">Home</a>
                <span>/</span>
                <span>GMF Italy</span>
            </div>
            <h1>GMF Italy</h1>
            </div>
        </section>
        {/* =========================
            BOARD MEMBERS
        ========================= */}
        <section className="board-members">
            <div className="container">
            <div className="members-grid">
                <div className="member-card">
                <div className="member-img">
                    <img src="img/members/fransisco.jpeg" alt="FRANSISCO" />
                </div>
                <h3>FRANCISCO REYES</h3>
                <span>(President Italy)</span>
                </div>
                {/*<div class="member-card">
                <div class="member-img">
                    <img src="img/members/Acharya-Lokesh-Muni.jpg" alt="ACHARYA LOKESH MUNI">
                </div>
                <h3>ACHARYA LOKESH MUNI</h3>
                <span>VICE CHAIRMAN</span>
            </div>

            <div class="member-card">
                <div class="member-img">
                    <img src="img/members/savita-singh.jpg" alt="DR. SAVITA SINGH">
                </div>
                <h3>DR. SAVITA SINGH</h3>
                <span>VICE PRESIDENT</span>
            </div>-*/}
            </div>
            </div>
        </section>
        </div>

      <Footer />
    </>
  )
}
